export default function getDiscountedPrice(originalPrice, promo, ticketType, priceTier, inventoryId, sectionId) {
  if (!promo) return originalPrice;

  if (promo.applies_to === 'ga' && ticketType !== 'ga') return originalPrice;
  if (promo.applies_to === 'seated' && ticketType !== 'seated') return originalPrice;

  if (promo.applies_to === 'specific_tiers' && promo.price_tiers.length > 0) {
    const tierMatch = (priceTier && promo.price_tiers.includes(priceTier))
      || (sectionId && promo.price_tiers.includes(sectionId));
    if (!tierMatch) return originalPrice;
  }

  if (ticketType === 'ga' && promo.ticket_inventories.length > 0) {
    if (!inventoryId || !promo.ticket_inventories.includes(inventoryId)) return originalPrice;
  }

  let discounted;
  if (promo.discount_type === 'percent') {
    discounted = originalPrice * (1 - promo.discount_value / 100);
  } else {
    discounted = originalPrice - promo.discount_value;
  }

  return Math.max(0, Math.round(discounted * 100) / 100);
}
